import React, { FC, useCallback, useEffect } from "react";
import { PageRoutes, setClass, useStore, useViewModel } from "../../utils";
import { FilterViewModel } from "./FilterViewModel";
import { CalendarColorsStore, PushStore } from "../../store";
import { AddMembersIcon, BellMobile, BurgerMenu, LoginLogo, LogoutIcon, Schedule } from "../svgs";
import { LoginViewModel, ProfileViewModel } from "../../views";
import { Checkbox } from "../checkbox";
import { observer } from "mobx-react-lite";
import { Loader } from "../loader";
import { Link, useNavigate } from "react-router-dom";
import { Rooms } from "./components";
import { MeetingViewModel } from "@components";
import '../../styles/components/filterMobile.scss';

export const FilterMobile: FC = observer(() => {
  const filterViewModel = useViewModel(FilterViewModel);
  const profileViewModel = useViewModel(ProfileViewModel);
  const meetingViewModel = useViewModel(MeetingViewModel);
  const auth = useViewModel(LoginViewModel);

  const pushStore = useStore(PushStore);
  const calendarColorStore = useStore(CalendarColorsStore);

  useEffect(() => {
    filterViewModel.onInit();
  }, []);

  const onSwitchFilter = () => {
    filterViewModel.setOpenPanel(!filterViewModel.openPanel);
  }

  const resetData = useCallback(() => {
    filterViewModel.resetEmployeeAndRoom();
    filterViewModel.resetFilters();
    meetingViewModel.resetMeetingData();
    filterViewModel.setMonthCalendar();
  }, []);
  
  const resetMeetingDataAndClosePanel = () => {
    meetingViewModel.resetMeetingData();
    filterViewModel.setOpenPanel(false);
  }

  const resetDataAndClosePanel = () => {
    resetData();
    filterViewModel.setOpenPanel(false);
  }

  const logout = () => {
    onSwitchFilter();
    pushStore.disconnect();
    pushStore.clearPushs();
    auth.logout();
  };

  const onChooseRoom = useCallback((roomNumber: number) => {
    resetMeetingDataAndClosePanel();
    filterViewModel.setSelectRoom(roomNumber);
    useNavigate()(PageRoutes.CALENDAR_PAGE);
  }, []);
  
  return (
    <>
      <div 
        className={setClass('shadow', filterViewModel.openPanel && 'open')}
        onClick={onSwitchFilter}
      />

      <div className={setClass('filter-mobile', filterViewModel.openPanel && 'open')}>

        {/* Хедер фильтра */}
        <div className="filter-header">
          <Link 
            className='reset-link' 
            to={PageRoutes.CALENDAR_PAGE} 
            onClick={resetDataAndClosePanel}
          >
            <LoginLogo allClassName='login-logo' />
          </Link>
          <BurgerMenu onClick={onSwitchFilter}/>
        </div>

        {/* Блок профиля */}
        <Link 
          className='reset-link' 
          to={PageRoutes.PROFILE_PAGE} 
          onClick={onSwitchFilter}
        >
          <div className="filter-profile-info">
            <img className="avatar" src={profileViewModel.profileInfo.img}/>
            <div className="text-block">
              <div className="name">{profileViewModel.profileInfo.fullName}</div>
              <div className="email">{profileViewModel.profileInfo.corporateEmail}</div>
            </div>
          </div>
        </Link>

        {/* Список режимов календарей (пока только расписание) */}
        <div className="calendar-modes">
          <Link 
            className="reset-link calendar-mode" 
            to={PageRoutes.CALENDAR_PAGE}
            onClick={resetDataAndClosePanel}
          >
            <>
              <Schedule />
              <p>Расписание</p>
            </>
          </Link>
        </div>

        {/* Список подключенных календарей */}
        <div className="line" />
        <div className="calendar-list-mobile">
          {!filterViewModel.isCalendarsLoading 
            ? filterViewModel.privateCalendars?.map((calendar) => (
              <div className='private-calendar' key={calendar.calendarUri}>
                <Checkbox
                  label={calendar.title}
                  value={calendar.isSelected}
                  color={calendarColorStore.getColorByName(calendar.calendarColor).hexCode}
                  onChange={() => filterViewModel.setCheckedCalendar(calendar)}
                  labelClassName="label"
                />
              </div>
            ))
            : <Loader />
          }
        </div>

        {/* Блок фильтров по сотрудникам и КФЗ */}
        <div className="line" />
        <div className="filter-list">
          <Link 
            to={PageRoutes.EMPLOYEES_PAGE} 
            className="reset-link" 
            onClick={resetMeetingDataAndClosePanel}
          >
            <div className="filter-option">
              <AddMembersIcon />
              <p>Сотрудники</p>
            </div>
          </Link>
          <Rooms
            isLoading={filterViewModel.roomsLoading}
            rooms={filterViewModel.rooms}
            selectRoomNumber={filterViewModel.selectRoomCabinetNumber}
            onChooseRoom={onChooseRoom}
          />
        </div>

        {/* Блок дополнительной информации */}
        <div className="line" />
        <div className="settings">
          <Link 
            className='reset-link' 
            to={PageRoutes.PUSH_PAGE} 
            onClick={onSwitchFilter}
          >
            <div className="setting">
              <BellMobile />
              <p>Уведомления</p>
            </div>
          </Link>

          <div 
            className="setting" 
            onClick={logout}
          >
            <LogoutIcon />
            <p>Выход</p>
          </div>
        </div>
      </div>
    </>
  )
});
